import React, { useState, useEffect } from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  ImageBackground,
  Image,
  Text,
  View
} from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { COLORS, FONTS, IMAGES } from '../constants';
import { LinearGradient } from 'expo-linear-gradient';
import { MaterialIcons } from '@expo/vector-icons';
import { Today } from "../components";

export default function FinalTestResultScreen({ route }) {
  const navigation = useNavigation();

  const disciplinesData = require('../../assets/json/dyscypliny.json')

  const table_1MData = require('../../assets/json/table_1M.json') //bieganie
  const table_2MData = require('../../assets/json/table_2M.json') //TODO pływanie json file 
  const table_3MData = require('../../assets/json/table_3M.json')
  const table_4MData = require('../../assets/json/table_4M.json')
  const table_5MData = require('../../assets/json/table_5M.json')
  const table_6MData = require('../../assets/json/table_6M.json')
  const table_7MData = require('../../assets/json/table_7M.json') // TODO dokonczyc

  const table_1KData = require('../../assets/json/table_1M.json') //TODO json file
  const table_2KData = require('../../assets/json/table_2M.json') //TODO json file
  const table_3KData = require('../../assets/json/table_3M.json') //TODO json file
  const table_4KData = require('../../assets/json/table_4M.json') //TODO json file
  const table_5KData = require('../../assets/json/table_5M.json') //TODO json file
  const table_6KData = require('../../assets/json/table_6M.json') //TODO json file
  const table_7KData = require('../../assets/json/table_7M.json') //TODO json file

  const [d1Score, setD1Score] = useState(0);
  const [d1min, setD1min] = useState(false);
  const [d2Score, setD2Score] = useState(0);
  const [d2min, setD2min] = useState(false);
  const [d3Score, setD3Score] = useState(0);
  const [d3min, setD3min] = useState(false);
  const [d4Score, setD4Score] = useState(0);
  const [d4min, setD4min] = useState(false);
  const [totalScore, setTotalScore] = useState(0);

  const [state, setState] = useState({
    d1: route.params.d1Key !== "" ? route.params.d1Key : "",
    d2: route.params.d2Key !== "" ? route.params.d2Key : "",
    d3: route.params.d3Key !== "" ? route.params.d3Key : "",
    d4: route.params.d4Key !== "" ? route.params.d4Key : "",
    d1name: route.params.d1nameKey !== "" ? route.params.d1nameKey : "",
    d2name: route.params.d2nameKey !== "" ? route.params.d2nameKey : "",
    d3name: route.params.d3nameKey !== "" ? route.params.d3nameKey : "",
    d4name: route.params.d4nameKey !== "" ? route.params.d4nameKey : "",
    ageGroup: route.params.ageGroupKey,
    sex: route.params.sexKey,
    category: route.params.categoryKey,
    selectedPosition: route.params.selectedPositionKey,
    finalScore: 0, // zdobyte punkty
    resultNumber: 0, // ocena
    resultText: "", // ocena opisowa
    icon: ""
  });

  const calculateScore = () => {
    // >> DYCYPLINA 1 BIEGANIE <<
    if (state.d1name === "Bieg") {
      let d1Input = parseFloat((Math.floor(state.d1 * 20) / 20).toFixed(2));

      if (state.sex === "M") {
        if (d1Input <= 12.0) {
          console.log("Maksymalna liczba punktów za bieganie dla M");
          setD1Score(44);
          setTotalScore((prev) => prev + 44);
          setD1min(true);
        } else if (d1Input <= 26 && d1Input > 12) {
          table_1MData.forEach((record) => {
            // console.log(typeof(d1Input), parseFloat(record.result), ":", parseFloat(record[state.ageGroup]) );
            if (parseFloat(record.result) === d1Input) {
              setD1Score(record[state.ageGroup]);
              setTotalScore((prev) => prev + parseFloat(record[state.ageGroup]));
              (record[state.ageGroup] >= 26) && setD1min(true);
            }
          })
        }
      } else {
        //TODO same problemy z tymi kobietami
        if (d1Input <= 14.0) {
          console.log("Maksymalna liczba punktów za bieganie dla K");
          setD1Score(44);
          setTotalScore((prev) => prev + 44)
        } else {
          table_1KData.forEach((record) => {
            if (parseInt(record.result) === d1Input) {
              setD1Score(record[state.ageGroup]);
              setTotalScore((prev) => prev + parseFloat(record[state.ageGroup]))
            }
          })
        }
      }
      // >> DYCYPLINA 1 PŁYWANIE <<
    } else if (state.d1name === "Pływanie") {
      let d1Input = (Math.floor(state.d1 / 5) * 5);

      if (state.sex === "M") {
        if (d1Input >= 650) {
          console.log("Maksymalna liczba punktów za pływanie");
          setD1Score(44);
          setTotalScore((prev) => prev + 44)
          setD1min(true);
        } else if (d1Input >= 45 && d1Input < 650) {
          table_2MData.forEach((record) => {
            // console.log(typeof(d1Input), parseInt(record.result), ":", parseFloat(record[state.ageGroup]) );
            if (parseInt(record.result) === d1Input) {
              setD1Score(record[state.ageGroup]);
              setTotalScore((prev) => prev + parseFloat(record[state.ageGroup]));
              (record[state.ageGroup] >= 26.5) && setD1min(true);
            }
          })
        }
      } else {
        //TODO kobiety
      }
    }
    // >> DYCYPLINA 2 PODDCIAGANIE <<
    if (state.d2name === "Podciąganie") {
      let d2Input = state.d2;

      if (state.sex === "M") {
        // (d2Input >= 9) && setD2min(true);
        if (d2Input >= 18) {
          console.log("Maksymalna liczba punktów za podciąganie dla M");
          setD2Score(21);
          setTotalScore((prev) => prev + 21);
          setD2min(true);
        } else {
          table_3MData.forEach((record) => {
            // console.log(typeof(d2Input), parseInt(record.result), ":", parseFloat(record[state.ageGroup]) );
            if (parseInt(record.result) === d2Input) {
              setD2Score(record[state.ageGroup]);
              setTotalScore((prev) => prev + parseFloat(record[state.ageGroup]));
              (record[state.ageGroup] >= 9) && setD2min(true);
            }
          })
        }
      } else {
        //TODO kobiety
      }
      // >> DYCYPLINA 2 POMPKI <<
    } else if (state.d2name === "Pompki") {
      let d2Input = parseFloat(state.d2);
      // console.log((d2Input))
      if (state.sex === "M") {
        if (d2Input >= 74) {
          console.log("Maksymalna liczba punktów za pływanie");
          setD2Score(21);
          setTotalScore((prev) => prev + 21);
          setD2min(true);
        } else {
          table_4MData.forEach((record) => {
            // console.log(typeof(d2Input), parseInt(record.result), ":", parseFloat(record[state.ageGroup]) );
            if (parseFloat(record.result) === d2Input) {
              setD2Score(record[state.ageGroup]);
              setTotalScore((prev) => prev + parseFloat(record[state.ageGroup]));
              (record[state.ageGroup] >= 11) && setD2min(true);
            }
          })
        }
      } else {
        //TODO kobiety
      }
    }
    // >> DYCYPLINA 3 10x10 <<
    if (state.d3name === "10x10") {
      if (state.sex === "M") {
        // (state.d3 >= 2) && setD3min(true);
        if (state.d3 <= 28.6) {
          console.log("Maksymalna liczba punktów za 10x10 dla M");
          setD3Score(19);
          setTotalScore((prev) => prev + 19);
          setD3min(true);
        } else if (state.d3 <= 36.4 && state.d3 > 28.6) {
          table_5MData.forEach((record) => {
            if (parseFloat(record.result) === parseFloat(state.d3)) {
              setD3Score(record[state.ageGroup]);
              setTotalScore((prev) => prev + parseFloat(record[state.ageGroup]));
              (record[state.ageGroup] >= 2) && setD3min(true);
            }
          })
        }
      } else {
        //TODO same problemy z tymi kobietami
        if (state.d3 <= 30.7) {
          console.log("Maksymalna liczba punktów za 10x10 dla K");
          setD1Score(19);
          setTotalScore((prev) => prev + 19);
        } else {
          table_5KData.forEach((record) => {
            if (parseFloat(record.result) === state.d3) {
              setD3Score(record[state.ageGroup]);
              setTotalScore((prev) => prev + parseFloat(record[state.ageGroup]))
            }
          })
        }
      }
      // >> DYCYPLINA 3 KOPERTA <<
    } else if (state.d3name === "Koperta") {
      if (state.sex === "M") {
        // (state.d3 >= 10) && setD3min(true);
        if (state.d3 <= 22.6) {
          console.log("Maksymalna liczba punktów za Kopertę dla M");
          setD3Score(19);
          setTotalScore((prev) => prev + 19);
          setD3min(true);
        } else if (state.d3 <= 34.5 && state.d3 > 22.6) {
          table_6MData.forEach((record) => {
            // console.log( state.d3, parseFloat(record.result), ":", parseFloat(record[state.ageGroup]));
            if (parseFloat(record.result) === parseFloat(state.d3)) {
              console.log("punkty", parseFloat(record[state.ageGroup]));

              setD3Score(record[state.ageGroup]);
              setTotalScore((prev) => prev + parseFloat(record[state.ageGroup]));
              (record[state.ageGroup] >= 10) && setD3min(true);
            }
          })
        }
      } else {
        //TODO same problemy z tymi kobietami
        if (state.d3 <= 25) {
          console.log("Maksymalna liczba punktów za Kopertę dla K");
          setD1Score(19);
          setTotalScore((prev) => prev + 19)
        } else {
          table_6KData.forEach((record) => {
            if (parseFloat(record.result) === state.d3) {
              setD3Score(record[state.ageGroup]);
              setTotalScore((prev) => prev + parseFloat(record[state.ageGroup]))
            }
          })
        }
      }
    }
    // >> DYCYPLINA 4 BRZUSZKI <<
    if (state.sex === "M") {
      // (state.d4 >= 10) && setD4min(true);
      if (state.d4 >= 80) {
        console.log("Maksymalna liczba punktów za Brzuszki dla M");
        setD4Score(16);
        setTotalScore((prev) => prev + 16);
        setD4min(true);
      } else {
        table_7MData.forEach((record) => {
          if (parseInt(record.result) === state.d4) {
            setD4Score(record[state.ageGroup]);
            setTotalScore((prev) => prev + parseInt(record[state.ageGroup]));
            (record[state.ageGroup] >= 10) && setD4min(true);
          }
        })
      }
    } else {
      //TODO same problemy z tymi kobietami
      if (state.d4 >= 60) {
        console.log("Maksymalna liczba punktów za Brzuszki dla K");
        setD4Score(16);
        setTotalScore((prev) => prev + 16)

      } else {
        table_7KData.forEach((record) => {
          if (parseInt(record.result) === state.d4) {
            setD4Score(record[state.ageGroup]);
            setTotalScore((prev) => prev + parseInt(record[state.ageGroup]))
          }
        })
      }
    }

    // setState({
    //   d1name: route.params.d1nameKey !== "" ? route.params.d1nameKey : "",
    //   d2name: route.params.d2nameKey !== "" ? route.params.d2nameKey : "",
    //   d3name: route.params.d3nameKey !== "" ? route.params.d3nameKey : "",
    //   d4name: route.params.d4nameKey !== "" ? route.params.d4nameKey : "",
    //   ageGroup: route.params.ageGroupKey,
    //   sex: route.params.sexKey,
    //   category: route.params.categoryKey,
    //   selectedPosition: route.params.selectedPositionKey,
    //   finalScore: totalScore,
    //   // resultNumber: "? ? ?",
    //   // resultText: "...",
    //   resultIcon: IMAGES.successIcon
    // });
  };


  const evaluateScore = (val) => {
    // alert("total score", val)
  }

  const onScreenLoad = () => {
    if (route.params.d1Key !== "" && route.params.d2Key !== "" && route.params.d3Key !== "" && route.params.d4Key !== "") {
      setState({
        d1: route.params.d1Key,
        d2: route.params.d2Key,
        d3: route.params.d3Key,
        d4: route.params.d4Key,
        d1name: route.params.d1nameKey,
        d2name: route.params.d2nameKey,
        d3name: route.params.d3nameKey,
        d4name: route.params.d4nameKey,
        ageGroup: route.params.ageGroupKey,
        sex: route.params.sexKey,
        category: route.params.categoryKey,
        selectedPosition: route.params.selectedPositionKey
      });

      calculateScore();
    }
    else {
      setState({
        d1name: route.params.d1nameKey,
        d2name: route.params.d2nameKey,
        d3name: route.params.d3nameKey,
        d4name: route.params.d4nameKey,
        ageGroup: route.params.ageGroupKey,
        sex: route.params.sexKey,
        category: route.params.categoryKey,
        selectedPosition: route.params.selectedPositionKey,
        finalScore: "Błąd danych",
        resultNumber: "? ? ?",
        resultText: "...",
        resultIcon: IMAGES.speechIcon
      });
    }
  }

  useEffect(() => {
    onScreenLoad();
    evaluateScore(totalScore);

  }, [])

  return (
    <>
      <View style={styles.container}>
        <Text style={styles.titleText}>
          PUNKTACJA
        </Text>
        <Text style={[styles.subtitleText, { color: COLORS.accent }]}>
          {state.sex} / {state.category} / Gr. {state.ageGroup} / Kolumna {state.selectedPosition}
        </Text>
        <Text style={{ paddingBottom: 10 }}>
          <Today />
        </Text>

        <LinearGradient
          colors={['#323638', '#232526']}
          style={styles.shieldBg}
        >
          <LinearGradient
            colors={['#232526', '#404445', '#323638']}
            style={styles.concave}
          />

          <LinearGradient
            colors={['#F8A402', '#CC8700']}
            style={[styles.shield, styles.shadowProp]}
          >
            <Image
              source={state.resultIcon}
              style={styles.resultIcon}
            />
            <Text style={styles.infoText}>Zdobyłeś</Text>
            <Text style={styles.headingText}>

              {totalScore}

              {/* {state.finalScore !== "Błąd danych" ? state.finalScore : "x x x"} */}
            </Text>
            <Text style={styles.infoText}>punkt(ów)</Text>

            <View style={[styles.separator, { backgroundColor: '#FFDCA6' }]} />
            <View style={[styles.separator, { backgroundColor: '#FFC770' }]} />

            <Text style={[styles.infoText, !d1min && { color: COLORS.error, fontWeight: 'bold' }]}>
              {state.d1name} : {d1Score} pkt
            </Text>
            <Text style={[styles.infoText, !d2min && { color: COLORS.error, fontWeight: 'bold' }]}>
              {state.d2name} : {d2Score} pkt
            </Text><Text style={[styles.infoText, !d3min && { color: COLORS.error, fontWeight: 'bold' }]}>
              {state.d3name} : {d3Score} pkt
            </Text><Text style={[styles.infoText, !d4min && { color: COLORS.error, fontWeight: 'bold' }]}>
              {state.d4name} : {d4Score} pkt
            </Text>

            <TouchableOpacity
              onPress={() => navigation.navigate('Rating', {
                category: state.selectedPosition
              }
              )}
            >
              <LinearGradient
                colors={['rgba(0,0,0,0.2)', 'transparent']}
                style={[styles.normyBtn]}
              >
                <Text style={{ color: COLORS.secondary, fontWeight: 'bold' }}>Normy oceniania</Text>
                {/* <MaterialIcons name="reset-tv" size={24} color={COLORS.light} /> */}
              </LinearGradient>
            </TouchableOpacity>
          </LinearGradient>

          {/* <Text style={[styles.infoText, { fontWeight: 'bold', marginTop: 10 }]}>Ocena</Text>
            <Text style={styles.headingText}>
              {state.resultNumber}
            </Text>
            <Text style={styles.infoText}>{state.resultText}</Text> */}

          <TouchableOpacity
            onPress={() => navigation.goBack()}
          >
            <LinearGradient
              colors={['rgba(0,0,0,0.2)', 'transparent']}
              style={[styles.backBtn, styles.shadowProp]}
            >
              {/* <Text>Cofnij</Text> */}
              <MaterialIcons name="reset-tv" size={24} color={COLORS.light} />
            </LinearGradient>
          </TouchableOpacity>

        </LinearGradient>

        <LinearGradient
          colors={['rgba(0,0,0,0.8)', 'transparent']}
          style={styles.button}>
        </LinearGradient>
      </View>
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: COLORS.background,
  },
  shieldBg: {
    flex: 0,
    minWidth: 300,
    minHeight: 500,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 5,
    borderRadius: 30,
  },
  concave: {
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 15,
    minWidth: 260,
    height: 20,
    borderRadius: 10,
    marginHorizontal: 20,
  },
  shield: {
    flex: 0,
    minWidth: 200,
    minHeight: 400,
    backgroundColor: COLORS.accent,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 20,
    paddingTop: 50,
    paddingVertical: 10,
    marginHorizontal: 30,
    paddingHorizontal: 20,
    borderRadius: 30,
  },
  separator: {
    height: 1,
    minWidth: 200,
    paddingHorizontal: 30
  },
  resultIcon: {
    position: 'absolute',
    top: -20,
    width: 80,
    height: 80
  },
  backBtn: {
    width: 80,
    height: 40,
    backgroundColor: COLORS.background,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 2,
    borderRadius: 10,
  },
  normyBtn: {
    width: 180,
    height: 40,
    backgroundColor: COLORS.light,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 2,
    borderRadius: 10,
  },
  shadowProp: {
    shadowColor: COLORS.background,
    shadowOffset: {
      width: -4,
      height: 6
    },
    shadowOpacity: 0.4,
    shadowRadius: 3,
  },
  infoText: {
    color: COLORS.primary,
    fontWeight: 100,
    paddingVertical: 3,
    fontSize: 16,
  },
  titleText: {
    ...FONTS.title,
  },
  headingText: {
    ...FONTS.title,
    fontSize: 56,
  },
  subtitleText: {
    ...FONTS.subtitle,
    color: COLORS.secondary,
    paddingVertical: 10
  },
})